import { createSessionExpirableStorageProvider } from '@atlassian/jira-browser-storage-providers';

export interface SessionStorageData {
	hasAccess: string;
}
const ONE_DAY = 24 * 60 * 60 * 1000; // 1 day
const storage = createSessionExpirableStorageProvider('jira-definitions-current-confluence-access');
storage.removeExpiredKeys();

export const getSessionStorageData = (key: string) => storage.get(key);

export const setSessionStorageData = (key: string, value: boolean | undefined) => {
	const expiresAt = Date.now() + ONE_DAY;
	storage.set(key, value, expiresAt);
};
